import React from 'react';
import BaseAddonCategoryUploader from './base-addon-category-uploader';

type UploadXlsAddonCategoryType = {
  xlsFile: File | null;
  setXlsFile: (item: File | null) => void;
  setAddons: (arg0: any[]) => void;
};

const UploadXlsBaseAddonCategory = ({
  xlsFile,
  setXlsFile,
  setAddons
}: UploadXlsAddonCategoryType) => {
  return (
    <BaseAddonCategoryUploader
      title='Add .xlsx file'
      setAddons={setAddons}
      file={xlsFile}
      setFile={setXlsFile}
    />
  );
};

export default UploadXlsBaseAddonCategory;
